import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

export const GlobalStyles = createGlobalStyle`
  ${reset};

  * {
    box-sizing: border-box;
  }

  html {
    position: relative;
    font-size: 62.5%;
  }

  body {
    font-family: ${({ theme }) => theme.font.family.secondary}, sans-serif;
    font-weight:  ${({ theme }) => theme.font.weights.regular};
    font-size:  ${({ theme }) => theme.font.sizes.bodySmall};
    width: 100%;
    min-height: 100vh;
    margin: 0;
    background:  ${({ theme }) => theme.colors.fadedLight};
    color: ${({ theme }) => theme.colors.darkest};
    text-size-adjust: 100%;
  }
`;
